import { z } from 'zod';
import { MAX_CHAR_LENGTH } from '../../constants';

type ErrorKeys = 'required_error' | 'total_mismatch' | 'description_too_long' | 'past_date';

export const AuctionConfigurationErrors = z.object({
  maxMintable: z.string().nullish(),
  maxQuantity: z.string().nullish(),
  minQuantity: z.string().nullish(),
  presaleMaxMintsPerWallet: z.string().nullish(),
  presaleMaxSupply: z.string().nullish(),
  presalePricePerMint: z.string().nullish(),
  publicMaxMintsPerWallet: z.string().nullish(),
  publicPricePerMint: z.string().nullish(),
  presaleStartTime: z.string().nullish(),
  publicStartTime: z.string().nullish(),
  presaleEndTime: z.string().nullish(),
  publicEndTime: z.string().nullish(),
  publicCutoffTime: z.string().nullish(),
  presaleAllowList: z.object({
    description: z.string().nullish(),
    addresses: z.string().nullish(),
  }),
});

const AuctionConfigurationErrorsOptions = AuctionConfigurationErrors.keyof().options;

export type AuctionConfigurationErrorKeys = (typeof AuctionConfigurationErrorsOptions)[number];

export type AuctionConfigurationErrors = (typeof AuctionConfigurationErrors)['_input'];

export const ErrorMessages = {
  publicPricePerMint: {
    required_error: 'Public price per mint is required',
  },
  presalePricePerMint: {
    required_error: 'Presale price per mint is required',
  },
  presaleEndTime: {
    required_error: 'Presale end time is required',
  },
  publicEndTime: {
    required_error: 'Public end time is required',
  },
  publicCutoffTime: {
    required_error: 'Public cut-off time is required',
  },
  publicStartTime: {
    required_error: 'Public start time is required',
    past_date: 'Public start time is in the past',
  },
  presaleStartTime: {
    required_error: 'Presale start time is required',
    past_date: 'Presale start time is in the past',
  },
  maxMintable: {
    required_error: 'Total mint supply is required',
  },
  presaleMaxSupply: {
    required_error: 'Presale max supply is required',
  },
  publicMaxMintsPerWallet: {
    required_error: 'Max mints per wallet is required',
  },
  presaleMaxMintsPerWallet: {
    required_error: 'Max mints per wallet is required',
  },
  maxQuantity: {
    required_error: 'Max quantity is required',
  },
  minQuantity: {
    required_error: 'Min quantity is required',
  },
  presaleAllowList: {
    description_too_long: `Description must be fewer than ${MAX_CHAR_LENGTH.presaleAllowList.description} characters`,
    required_error: 'Add one address or select collectors in the dropdown above to enable presale',
  },
} satisfies Record<AuctionConfigurationErrorKeys, Partial<Record<ErrorKeys, string>>>;
